// extracted by mini-css-extract-plugin
module.exports = {"RichText":"RichText_RichText__6D_41","RichText--Object":"RichText_RichText--Object__1-1u9"};